import React from 'react';

const BackArrow = (props: any) => (
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.3999 1.20007L1.5999 6.00282L6.3999 10.8001"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BackArrow;
